<template>
    <lv-base-column
        ref="column" v-bind="columnBinding">
        <template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
            <link-table-column-input-item
                :row="row"
                :edit-row="editRow"
                :row-index="rowIndex"
                :col="col"
                :col-index="colIndex"
                :fixed-row="fixedRow"
                v-bind="columnItemBinding"
                @click="lv_clickItem"
                @change="e=>$emit('change',e)"

                :type="type"
                :recommend="recommend"
                :recommend-lov="recommendLov"
                :color="color"
                :size="size"
                :shape="shape"
                :dashed="dashed"
                :prefixIcon="prefixIcon"
                :suffixIcon="suffixIcon"
                :placeholder="placeholder"
                :disabled="disabled"
                :readonly="readonly"
                :regexp="regexp"
				:rules="rules"
				:replacement="replacement"
                :input-width="width"
                :input-type="inputType"
                :focus-on-hover="focusOnHover"
            />
        </template>
    </lv-base-column>
</template>

<script>
    import LinkTableColumnInputItem from "./link-table-column-input-item";
    import {ColumnMixin} from "../mixins";
    import LvBaseColumn from "../../table/lv-base-column";

    export default {
        name: 'link-table-column-input',
        components: {LvBaseColumn, LinkTableColumnInputItem,},
        mixins: [ColumnMixin],
        props: {
            dataType: {required: false, type: String},      //数据显示类型
            type: {type: String,},
            recommend: {type: Array},                                                   //推荐下拉选项
            recommendLov: {type: String},                                               //推荐值列表类型
            recommendFilter: {type: Function},                                          //推荐输入自定义筛选函数
            color: {type: String,},
            size: {type: String,},
            shape: {type: String,},
            dashed: {type: Boolean,},
            prefixIcon: {type: String},
            suffixIcon: {type: String},
            placeholder: {type: String, default: '点击输入内容'},
            disabled: {type: Boolean},
            readonly: {type: Boolean},
            regexp: {type: RegExp},
            inputType: {type: String},
            focusOnHover: {type: Boolean, default: false},
			replacement: {type: String, default: ''},                                   // 设置替换文本或生成替换文本的函数。
        },
    };
</script>
